import React, { useEffect, useState } from "react";
import { api } from "@/api/client";

function initials(name) {
  const p = (name || "").trim().split(/\s+/).filter(Boolean);
  return ((p[0]?.[0] || "") + (p.length > 1 ? p[p.length - 1][0] : "")).toUpperCase() || null;
}

// 1a fix — agency-side profile photo. Raw Drive links 403 in an <img>, so (like the staff
// ProfileAvatar) we proxy the bytes as a blob through the AGENCY-scoped, allow-list-gated
// endpoint. 204 (no photo) resolves as a 0-byte blob → render the initials fallback.
export function AgencyAvatar({ freelancerId, hasPhoto, name, alt, className, style }) {
  const [objectUrl, setObjectUrl] = useState(null);
  useEffect(() => {
    if (!freelancerId || hasPhoto === false) { setObjectUrl(null); return; }
    let url, active = true;
    api.get(`/v1/build/agency/freelancers/${freelancerId}/profile-image`, { responseType: "blob", silent401: true })
      .then((r) => {
        if (!active) return;
        if (!r.data || r.data.size === 0) { setObjectUrl(null); return; }
        url = window.URL.createObjectURL(r.data);
        setObjectUrl(url);
      }).catch(() => { if (active) setObjectUrl(null); });
    return () => { active = false; if (url) window.URL.revokeObjectURL(url); };
  }, [freelancerId, hasPhoto]);
  if (objectUrl) return <img src={objectUrl} alt={alt || ""} className={className} style={style} loading="lazy" decoding="async" />;
  const ini = initials(name);
  return (
    <div className={className} style={{ display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 600, color: "#8A8A8A", ...style }}>
      {ini}
    </div>
  );
}
